package com.evoapps.evoshift.domain.usecase.shift

import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.domain.repository.ShiftRepository
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope

/**
 * Marks unassigned shifts as open in one go (the "keep them as open shifts" choice when
 * publishing). Assigned shifts are left alone: an assigned shift is never open.
 */
class MarkShiftsOpenUseCase(
    private val shiftRepository: ShiftRepository
) {
    suspend operator fun invoke(shiftIds: Collection<String>, editorUserId: String): Result<Int> = runCatching {
        val now = AppClock.now().toString()
        // Fresh copies, read in parallel, then one batched write (a month can have dozens).
        val current = coroutineScope {
            shiftIds.map { id -> async { shiftRepository.getShift(id).getOrThrow() } }.awaitAll()
        }
        val opened = current.filter { it.userId == null && !it.isOpen }.map { shift ->
            shift.copy(
                isOpen = true,
                hasUnpublishedChanges = shift.isPublished || shift.hasUnpublishedChanges,
                metadata = shift.metadata.copy(updatedAt = now, updatedBy = editorUserId)
            )
        }
        if (opened.isNotEmpty()) shiftRepository.updateShifts(opened).getOrThrow()
        opened.size
    }
}
